import {WorkflowConfigState} from './workflow-config.state';
import {IgenomicsAction} from '../../core/interfaces/genomics-action.interface';
import {WorkflowConfigActions} from './workflow-config.actions';
import {GeneralStoreEntity} from '../../core/entities/general-store.entity';
import {CORE_ACTIONS} from '../../core/constants/core-actions.constant';
import {cloneDeep} from "lodash";

export function workflowConfig(state: WorkflowConfigState = {}, action: IgenomicsAction<GeneralStoreEntity>): WorkflowConfigState {
  let payload;
  switch (action.type) {
    case WorkflowConfigActions.StartFetching: {
      return {};
    }
    case WorkflowConfigActions.Set: {
      payload = cloneDeep(action.payload);
      return payload.upsert(state, 'uiConfig');
    }
    case WorkflowConfigActions.SetActiveWorkflow: {
      payload = cloneDeep(action.payload);
      return payload.upsert(state, 'activeWorkflow');
    }
    case WorkflowConfigActions.SetResourceMap: {
      payload = cloneDeep(action.payload);
      return payload.upsert(state, 'resourcesMap');
    }
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS: {
      payload = cloneDeep(action.payload);
      return payload.init(state, null, {});
    }
    default:
      return state;
  }
}
